import { onError } from '@apollo/client/link/error';
import { handleLogout } from '../../utils';
import { INVALID_AUTH_TOKEN, TOKEN_INVALID, UNAUTHENTICATED, UNAUTHORIZED } from '../../../../../shared/lib/constants';

export const logoutLink = onError(({ graphQLErrors }) => {
  (async () => {
    if (graphQLErrors && graphQLErrors.length > 0) {
      graphQLErrors.map(async ({ extensions }) => {
        if (extensions) {
          const { code } = extensions;

          if (code === UNAUTHENTICATED) {
            await handleLogout();
          }
        }
      });

      const [{ message }] = graphQLErrors;

      if (message === UNAUTHORIZED || message === TOKEN_INVALID || message === INVALID_AUTH_TOKEN) {
        await handleLogout();
      }
    }
  })();
});
